import React from 'react'
import styled from '@emotion/styled'
import { IconProps } from '../../models/IconProps'
const BaseComponent = ({ size = 24, tabIndex = -1, focusable = false, ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
      tabIndex={tabIndex}
      focusable={focusable}
      fill="currentColor"
      {...props}
    >
      <path
        d="M346,110a34,34,0,0,0-68,0v34h34A34,34,0,0,0,346,110Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M234,110a34,34,0,1,0-34,34h34Z"
        style={{
          fill: 'none',
        }}
      />
      <path d="M234,144h44V256H442a22,22,0,0,0,22-22V166a22,22,0,0,0-22-22H382.18A77.95,77.95,0,0,0,256,55.79,78,78,0,0,0,129.81,144H70a22,22,0,0,0-22,22v68a22,22,0,0,0,22,22H234Zm44-34a34,34,0,1,1,34,34H278Zm-112,0a34,34,0,1,1,68,0v34H200A34,34,0,0,1,166,110Z" />
      <path d="M278,480H410a22,22,0,0,0,22-22V288H278Z" />
      <path d="M80,458a22,22,0,0,0,22,22H234V288H80Z" />
    </svg>
  )
}
export default styled(BaseComponent)`
  outline: none;
`
